module.exports = __webpack_public_path__ + "assets/img/36_451_big.c087a44b.jpg";